import {
  FETCH_BRAND_PENDING,
  FETCH_BRAND_REJECTED,
  FETCH_BRAND_FULFILLED,
} from 'constants/brandDetail';

const initialState = {
  pending: true,
  brand: {},
  error: {},
  success: false,
};

export const brandDetail = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BRAND_FULFILLED:
      return {
        ...state,
        brandData: action.response,
        pending: false,
        success: true,
      };

    case FETCH_BRAND_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_BRAND_PENDING:
      return {
        ...state,
        error: {},
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/brandDetail.js